<template>
  <BasePage data-test-id="settingsView">
    <v-tabs
      v-model="settingsStore.selectedTab"
      show-arrows
      align-tabs="start"
      density="compact"
      color="primary"
      :grow="false"
    >
      <v-tab :key="SettingsTab.Account" :value="SettingsTab.Account">
        <v-icon icon="mdi-cogs"></v-icon>{{ t('tabs.settings.account') }}</v-tab
      >
      <v-tab :key="SettingsTab.Admins" :value="SettingsTab.Admins">
        <v-icon icon="mdi-account-key"></v-icon>{{ t('tabs.settings.admins') }}</v-tab
      >
      <v-tab :key="SettingsTab.Datasets" :value="SettingsTab.Datasets">
        <v-icon icon="mdi-database"></v-icon>{{ t('tabs.settings.datasets') }}</v-tab
      >
      <v-tab :key="SettingsTab.CustomFields" :value="SettingsTab.CustomFields">
        <v-icon icon="mdi-account-clock"></v-icon>{{ t('tabs.settings.customFields') }}</v-tab
      >
      <v-tab :key="SettingsTab.Masks" :value="SettingsTab.Masks">
        <v-icon icon="mdi-face-mask"></v-icon>{{ t('tabs.settings.masks') }}</v-tab
      >
      <v-tab :key="SettingsTab.Devices" :value="SettingsTab.Devices">
        <v-icon icon="mdi-package"></v-icon>{{ t('tabs.settings.devices') }}</v-tab
      >
      <v-tab
        :disabled="!appStore.isProgramAdmin"
        :key="SettingsTab.Import"
        :value="SettingsTab.Import"
      >
        <v-icon icon="mdi-import"></v-icon>{{ t('tabs.settings.import') }}</v-tab
      >
      <v-tab :key="SettingsTab.Templates" :value="SettingsTab.Templates">
        <v-icon icon="mdi-email-edit"></v-icon>{{ t('tabs.settings.templates') }}</v-tab
      >
    </v-tabs>
    <v-divider />
    <v-tabs-window class="tab-content" v-model="settingsStore.selectedTab">
      <v-tabs-window-item :key="SettingsTab.Account" :value="SettingsTab.Account">
        <AccountView />
      </v-tabs-window-item>
      <v-tabs-window-item :key="SettingsTab.Admins" :value="SettingsTab.Admins">
        <AdminsView />
      </v-tabs-window-item>
      <v-tabs-window-item :key="SettingsTab.Datasets" :value="SettingsTab.Datasets">
        <DatasetsView />
      </v-tabs-window-item>
      <v-tabs-window-item :key="SettingsTab.CustomFields" :value="SettingsTab.CustomFields">
        <CustomFieldsView />
      </v-tabs-window-item>
      <v-tabs-window-item :key="SettingsTab.Masks" :value="SettingsTab.Masks">
        <MasksView />
      </v-tabs-window-item>
      <v-tabs-window-item :key="SettingsTab.Devices" :value="SettingsTab.Devices">
        <DevicesView />
      </v-tabs-window-item>
      <v-tabs-window-item
        v-if="appStore.isProgramAdmin"
        :key="SettingsTab.Import"
        :value="SettingsTab.Import"
      >
        <ImportView />
      </v-tabs-window-item>
      <v-tabs-window-item :key="SettingsTab.Templates" :value="SettingsTab.Templates">
        <EmailTemplatesView />
      </v-tabs-window-item>
    </v-tabs-window>
  </BasePage>
</template>

<script setup lang="ts">
// STORES, IMPORTS, & COMPOSABLES
import { SettingsTab } from '@/enums/SettingsTab'
import { useAppStore } from '@/stores/ui/AppStore'
import { useSettingsStore } from '@/stores/ui/SettingsStore'
import AccountView from '@/views/settings/AccountView.vue'
import CustomFieldsView from '@/views/settings/CustomFieldsView.vue'
import DevicesView from '@/views/settings/DevicesView.vue'
import ImportView from '@/views/settings/ImportView.vue'
import MasksView from '@/views/settings/MasksView.vue'
import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import AdminsView from './settings/AdminsView.vue'
import DatasetsView from './settings/DatasetsView.vue'
import EmailTemplatesView from './settings/EmailTemplatesView.vue'

const { t } = useI18n({ useScope: 'global' })
const appStore = useAppStore()
const settingsStore = useSettingsStore()

// PROPS & EMITS

// REACTIVE VARIABLES

// COMPUTED PROPERTIES

// LIFECYCLE HOOKS
onMounted(() => {
  if (!appStore.isProgramAdmin && settingsStore.selectedTab === SettingsTab.Import) {
    settingsStore.selectedTab = SettingsTab.Account
  }
  // Any initialization logic can go here
})

// FUNCTIONS
</script>

<style lang="scss" scoped>
.tab-content {
  margin-top: 1em;
  margin-left: 1em;
}
</style>
